import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";

export function useProviderNotePermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  const canAddCaseNotes =
    permissions.includes("provider.add_providernote") ||
    permissions.includes("provider.add_providernotes") ||
    permissions.includes("casemanager.add_casenotes");

  const canEditCaseNotes =
    permissions.includes("provider.change_providernote") ||
    permissions.includes("provider.change_providernotes") ||
    permissions.includes("casemanager.change_casenotes");

  return {
    canAddCaseNotes,
    canEditCaseNotes,
    canSeeAISummary: false,
  };
}
